<template lang="pug">
  v-layout.box-coberturas-desktop-formatter(column align-center)
    v-flex(style="margin: 1em 0em")
      span(style="font-size:16px !important; color:#0855C4")
        b Estas son tus coberturas
    v-flex
      v-layout.box-table-coberturas(column)
        v-flex(v-if="textTitle1"  style="padding: 0.2em 0.5em !important;").box-detalle-cobertura
          span
            b {{textTitle1}}
        v-flex(v-if="textTitle1"  style="padding: 0.2em 0.5em !important;").box-detalle-cobertura
          v-layout.box-detalle-cobertura.box-detalle-cobertura-text(style="border-bottom:0px;padding-left:0;padding-right:0;")
            v-flex(xs8)
              span.nombre(style="font-size:14px") {{ coberturaPrincipal.nombre }}
            v-flex.box-detalle-cobertura-monto(xs4)
              span(style="font-size:13px") {{tipoMoneda}} {{coberturaPrincipal.monto}}
        v-flex.box-detalle-cobertura(style="padding: 0.2em 0.5em !important;")
          span
            b {{textTitle2||'Coberturas'}}
        v-flex(style="max-height:15em; overflow-y:auto")
          v-layout.box-detalle-cobertura.box-detalle-cobertura-text(v-for="cobertura in coberturaFormatter " :key="cobertura.id" )
            v-flex(xs8)
              span.nombre(style="font-size:14px") {{ cobertura.nombre }}
            v-flex.box-detalle-cobertura-monto(xs4)
              span(style="font-size:13px") {{tipoMoneda}} {{cobertura.monto}}
      v-layout.box-detalle-cobertura-text(style="margin: 1em auto")
        span(style="font-size:13px") Si deseas contratar más coberturas comunícate con tu &nbsp;
          b asesor.
</template>

<script>
import * as d3 from 'd3'
import { mapActions } from 'vuex'

export default {
  props: [
    'coberturas',
    'tipoMoneda',
    'taggeo',
    'textTitle1',
    'textTitle2'
  ],
  data () {
    return {
      coberturaFormatter: [],
      coberturaPrincipal: {}
    }
  },
  methods: {
    ...mapActions('event', ['eventLog'])
  },
  mounted () {
    let self = this
    const metadata = {
      numeroPoliza: self.taggeo.numeroPoliza,
      antiguedad: self.taggeo.antiguedad,
      productoConsultado: self.taggeo.ramo,
      subproductoConsultado: self.taggeo.nombreProducto
    }
    self.$root.$emit('npsInactivity', {seccion: 'Mis seguros - Plan - Coberturas', metadata})

    self.coberturaFormatter = self.coberturas.map(cobertura => {
      let aux = {}
      aux.nombre = cobertura.nombre
      aux.monto = new Intl.NumberFormat('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(cobertura.montoCobertura)

      return aux
    })

    d3.select('.box-coberturas-desktop-formatter')
      .style('opacity', '0')
      .transition().duration(300)
      .style('opacity', '1')

    self.eventLog({
      'tipoDocumento': self.taggeo.tipoDocumento,
      'numeroDocumento': self.taggeo.numeroDocumento,
      'categoria': 'Consulta',
      'nombre': self.taggeo.nombre,
      'datos': {
        'numeroPoliza': self.taggeo.numeroPoliza,
        'grupoProducto': self.taggeo.ramo,
        'producto': self.taggeo.nombreProducto,
        'navegacion': 'Plan',
        'dispositivo': 'desktop',
        'seccion': 'coberturas'
      }
    })
    if (this.taggeo.nombreProducto.includes('VIDA') && this.taggeo.nombreProducto.includes('FREE')) {
      self.coberturaPrincipal = self.coberturaFormatter.find(c => c.tipo === 'PRINCIPAL') || self.coberturaFormatter.find(c => c.nombre.toUpperCase() === 'FALLECIMIENTO')
      self.coberturaFormatter = self.coberturaFormatter.filter(c => (c.tipo && c.tipo !== 'PRINCIPAL') || (!c.tipo && c.nombre.toUpperCase() !== 'FALLECIMIENTO'))
    } else {
      self.coberturaPrincipal = self.coberturaFormatter[0]
    }
  }

}
</script>

<style scoped>
.box-coberturas-desktop-formatter span {
  font-size: 14px !important;
  line-height: 1em;
  color: var(--text-color);
}

.box-card-coberturas {
  padding: 2em 0.3em
}

.box-detalle-cobertura {
  padding: 1em 0.5em;
  border-bottom: 1px #C4C4C4 solid
}
.box-detalle-cobertura:last-child {
  padding: 1em 0.5em;
  border-bottom: 0px #C4C4C4 solid
}

.box-table-coberturas {
  border: 1px #C4C4C4 solid;
}

.box-coberturas-desktop-formatter {
  margin: 1em 1.5em;
}

.box-detalle-cobertura-text .flex {
  display: flex;
}

.box-detalle-cobertura-text span.nombre {
  text-transform: lowercase;
}

.box-detalle-cobertura-text span.nombre::first-letter {
  text-transform: uppercase;
}

.box-detalle-cobertura-monto {
  display: flex;
  justify-content: right;
  align-self: center;
}

.box-btn-coberturas-popup {
  height: 3.5em;
  width: 10em;
}
</style>



// WEBPACK FOOTER //
// src/components/mis-seguros/CoberturasDesktop.vue